import { useState } from "react"
import { party } from "../../../../data/party"
import ListSelect from "../../ListSelect"
import Btn from "../../Btn"

const Party =(props) => {

    const selectList = party.map(party => ({
        id:party.id,
        name:party.name,
        wood:party.wood,
        clay:party.clay,
        iron:party.iron,
        crop:party.crop,
        all: party.wood + party.clay + party.crop + party.iron
    }) )

    
    const [selectValue, setSelectValue] = useState("")
    const handleSelectValue = event => {
        setSelectValue(event.target.value)
    } 

    function vypis() {
        const selectedParty = selectList[selectValue-1]
        props.addItem(selectedParty)
    }

return (

    <div>
        <ListSelect label="...choose a party..." selectList={selectList} handleSelectValue={handleSelectValue} />
        {selectValue ? (
            <Btn className="btn" type="submit" text="Add to result" onClick={vypis} />
        ) : null}
    </div>
    

)

}
export default Party